import React, { useState } from "react";
import "./footer.css";
import '../Mobilemenu/mobilemenu.css'
// import HomeIcon from "@material-ui/icons/Home";
// import PersonIcon from "@material-ui/icons/Person";
// import AddIcon from "@material-ui/icons/Add";
// import NotificationsSharpIcon from "@material-ui/icons/NotificationsSharp";
// import SearchIcon from "@material-ui/icons/Search";
import MobileMenu from "../Mobilemenu/MobileMenu";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import MobileSettings from "../MobileSettings/MobileSettings";
import { isMobileSearch,notificationUpdate } from "../../services/actions/actions";
import Mobilesearch from "../Mobilesearch/Mobilesearch";
import {updateNotification} from "../../functions/apis"
import { useHistory } from "react-router-dom";
import MenuIcon from '@material-ui/icons/Menu';
import { BellIcon, HomeIcon, SearchIcon, UserCircleIcon, UserIcon } from '@heroicons/react/outline';
function Footer({ rootData,isMobileSearchs,notificationUpdates }) {
  let history = useHistory();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [setting, setSetting] = useState(false);
  const menuOpen = () => {
    setIsMenuOpen(true);
  };
  const handleNotification = () => {
    notificationUpdates();
    updateNotification(rootData.notificationId);
  }

  return (
    <>
      <div className="mobileFooter bg-color-2 py-2 flex lg:hidden">
        <div className="left_footer_section text-center flex justify-around items-center">
          <Link to={"/"}>
            <HomeIcon className=' w-6 text-gray-50' />
          </Link>
          <div className="relative">
          <BellIcon className="footer_icon w-6 text-gray-50" onClick={() => {handleNotification();history.push('/device/notification')}}/>
          {rootData.haveNotification === true && <div className="redAlert w-2 h-2 bg-red-700 rounded-full absolute top-0 right-0"></div>}
          </div>

        </div>
        <button className="mobileAddBtn bg-color-2" onClick={() => menuOpen()}>
          <MenuIcon className="addIcon" />
        </button>
        <div className="right_footer_section text-center flex justify-around items-center">
          <SearchIcon className="w-6 text-gray-50 footer_icon" onClick={() => isMobileSearchs(true)}/>
          {rootData.user.avatar ? (
            <>
              <img
                src={rootData.user.avatar}
                alt="profile"
                className="header-profile"
                onClick={() => setSetting(true)}
              />
            </>
          ) : (
            <UserCircleIcon className="footer_icon w-6 text-gray-50" />
          )}
        </div>
      </div>
      <div
        className={`fixed w-full h-full top-0  backdrop-blur-md z-50 menubackground ${
          isMenuOpen ? "" : "hidden"
        }`}
      >
        <div>
          <div>
            <MobileMenu
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={() => setIsMenuOpen()}
            />
          </div>
        </div>
      </div>
      <div
        className={`fixed w-full h-full top-0 ${setting ? "" : "hidden"}`}
        style={{ backgroundColor: "#00000063" }}
      >
        <MobileSettings setting={setting} close={() => setSetting(false)}/>
      </div>
      <Mobilesearch className={rootData.isMobileSearch ? '' : 'hidden'} view={rootData.isMobileSearch}/>
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToState = (dispatch) => {
  return {
    isMobileSearchs: (value) => {
      dispatch(isMobileSearch(value));
    },
    notificationUpdates: (value) => {
      dispatch(notificationUpdate(value));
    },

  };
};

export default connect(mapStateToProps, mapDispatchToState)(Footer);
